import type { ShopifyProduct } from 'types/product/ShopifyProduct';

export const getProductVariant = (
  product: ShopifyProduct,
  merchandiseId: string,
) => product.variants.find((variant) => variant.id === merchandiseId);
